export enum AdditionalAreasEnum {
  EDUCATION = "education",
  EXPERIENCE = "experience",
  SKILLS = "skills",
  LANGUAGES = "languages",
}
